/* eslint-disable react/prop-types */
import React, { useMemo, useState, useEffect, useContext } from 'react';
import { HomeAreaSelectContent, HomeQuesTypeSelectContent, HomeLayoutOptionContent, HomeQuestionSelectContent, HomeQuestionReviewPage, HomeQuestionCompleteContent } from 'containers';
import {
  StepBox,
  fetchDataMachine,
  FETCH_DATA_EVENT,
  FETCH_DATA_STATE,
  Modal,
  AuthProvider,
  CreateExamPaperParamsProvider,
  MobileStepBox,
  EditCopyExamPaperProvider,
  openNotificationWithIcon,
} from '@oneclass/ui-components';
import { ExamPaperHeader } from 'components';
import { Button } from '@oneclass/onedesign';
import { FileAltSolid, ExclamationCircleSolid } from '@onedesign/icon';
import { useMachine } from '@xstate/react';
import { formateQuestionList, setCookie, getCookie } from 'utils/common';
import { putEditExamPaper, postExamCreate, postExamEdit } from 'api/examPaper';
import { postExportPaper } from 'api/exportPaper';
import { useBoolean } from 'ahooks';
import { useHistory } from 'react-router-dom';
import { StyledComputerQuestionPage, StyledHomePageContent, UiBtnZone } from './ComputerQuestionPage.style';
// import { useDeviceDetect } from 'utils/hooks/useDeviceDetect';
import { default as deviceProvider } from 'providers/deviceProvider.js';
import { postGetQuestionGroup } from 'api/query';
import { useLoadingContent } from 'utils/hooks/useLoadingContent';
import { postMemberTypeSetting } from 'api/member';
import { OUTPUT_TYPE_NAME } from 'constants/index';

const steps = [
  {
    title: '範圍選擇',
  },
  {
    title: '題型選擇',
  },
  {
    title: '試題選擇',
  },
  {
    title: '出題預覽',
  },
  {
    title: '版面配置',
  },
  {
    title: '出卷完成',
  },
];

const goTop = () => {
  const main = document.getElementById('mainLayout');
  main.scrollTop = 0;
};

const initSaveData = {
  education: '',
  subject: '',
  areaParams: {},
  quesReviewQuestionRenderList: {},
  createExamPaperParams: {},
  tableData: {},
  bookOptions: [],
  examUID: ''
};
export const ComputerQuestionPage = ({ className }) => {
  // const { isDesktop } = useDeviceDetect();
  const { deviceData, deviceDataProviderChange } = useContext(deviceProvider.deviceProviderContext);
  const { editCopyExamPaperData, resetCopyEditPaperParams } = useContext(EditCopyExamPaperProvider.EditCopyExamPaperContext);
  const history = useHistory();
  const { useAuthState } = AuthProvider;
  const authState = useAuthState();
  const { createExamPaperParams: globalExamPaperData } = useContext(CreateExamPaperParamsProvider.createExamPaperContext);
  const [saveData, setSaveData] = useState({ ...initSaveData });
  const [resetToggle, setResetToggle] = useState(false);
  const [areaParams, setAreaParams] = useState({});
  const [sendParams, setSendParams] = useState({});
  const [questions, setQuestions] = useState([]);
  const [tableData, setTableData] = useState({});
  const [keyList, setKeyList] = useState([]);
  const [searchKey, setSearchKey] = useState('');
  const [totalQuesTypeData, setTotalQuesTypeData] = useState({});
  const [createExamPaperParams, setCreateExamPaperParams] = useState({});
  const [checkedSend, setCheckedSend] = useState([]);
  const [step, setStep] = useState(1);
  const [jumpStep, setJumpStep] = useState(null);
  const [scoreModalVisible, { toggle: setScoreModalToggle, setFalse: setScoreModalFalse }] = useBoolean(false);
  const [areaModalVisible, { toggle: setAreaModalToggle, setFalse: setAreaModalFalse }] = useBoolean(false);
  const [modalVisible, { toggle: setModalToggle, setFalse: setModalFalse }] = useBoolean(false);
  const { renderLoadingContent, isLoading, setIsLoading } = useLoadingContent();
  const [reCreateSearchParams, setReCreateSearchParams] = useState({});
  const [reCreateExam, setReCreateExam] = useState(false);
  const [isJumpToStep5, setIsJumpToStep5] = useState(false);
  const [emptyTextModalVisible, { toggle: setEmptyTextModalToggle, setFalse: setEmptyTextModalFalse }] = useBoolean(false);
  const [isGoBack, setIsGoBack] = useState(false);
  const [questionCountModalVisible, { toggle: setQuestionCountModalToggle, setFalse: setQuestionCountModalFalse }] = useBoolean(false);
  const [isShowQuestionLimitText, setIsShowQuestionLimitText] = useState(false);

  /// ------ 大更新 -----

  // 儲存使用者設定
  const [, sendUserSetting] = useMachine(fetchDataMachine, {
    services: {
      fetchData: async(_, event) => {
        const res = await postMemberTypeSetting(event.payload);
        const { isSuccess, systemCode, message } = res;
        if (isSuccess) {
          // 成功顯示
        } else {
          openNotificationWithIcon('error', message);
        }
        return {
          isSuccess, systemCode, message
        };
      }
    }
  });

  const getSendParams = (data) => {
    setSendParams(data);
  };

  // 組成試卷
  const doExportExam = (examUID) => {
    if (!examUID) return;
    if (sendParams.outputType === 'Files') {
      // 紙本卷類
      let typesetting = {};

      const {
        schoolName = {},
        paperName,
        teacherSign = {},
        grade = {},
        room = {},
        paperSize,
        wordSetting,
        paperContents,
        analyzeContent,
        amount,
        advanced,
        studentSign,
        eduSubject,
        outputType,
      } = sendParams || {};

      typesetting = {
        schoolName: checkedSend.findIndex(item => item === 'schoolName') !== -1 ? schoolName.value : '',
        paperName: paperName.value,
        teacherSign: checkedSend.findIndex(item => item === 'teacherSign') !== -1 ? teacherSign.value : '',
        grade: checkedSend.findIndex(item => item === 'classInfo') !== -1 ? grade.value : '',
        room: checkedSend.findIndex(item => item === 'classInfo') !== -1 ? room.value : '',
        eduSubject: checkedSend.findIndex(item => item === 'eduSubject') !== -1 ? eduSubject : '',
        studentSign: checkedSend.findIndex(item => item === 'studentSign') !== -1 ? studentSign : '',
        paperSize,
        wordSetting,
        paperContents: paperContents || [],
        analyzeContent: analyzeContent || [],
        amount,
        advanced: advanced || []
      };

      // 儲存常用設定
      sendUserSetting(FETCH_DATA_EVENT.FETCH, {
        payload: typesetting
      });

      // 組成試卷
      sendPostExportPaper(FETCH_DATA_EVENT.FETCH, {
        payload: {
          examUID,
          outputType,
          typesetting,
        }
      });

    } else {
      // 線上測驗
      const {
        advanced,
        outputType,
      } = sendParams || {};

      sendPostExportPaper(FETCH_DATA_EVENT.FETCH, {
        payload: {
          examUID,
          outputType,
          onlineSetting: {
            advanced,
          }
        }
      });
    }
  };

  // 建立測驗
  const [statePostExamCreate, sendPostExamCreate] = useMachine(fetchDataMachine, {
    services: {
      fetchData: async(_context, event) => {
        setIsLoading(true);
        const res = await postExamCreate(event.payload);
        const { data, isSuccess, systemCode, message } = res;
        const { examUID } = data;
        if (isSuccess) {
          doExportExam(examUID);
          setCreateExamPaperParams({
            ...createExamPaperParams,
            examUID: examUID,
          });
        }
        return {
          isSuccess, systemCode, message,
          data,
        };
      },
    },
  });

  const [stateGetQuestionType, sendGetQuestionType] = useMachine(fetchDataMachine, {
    services: {
      fetchData: async(_context, event) => {
        const res = await postGetQuestionGroup(event.payload);
        const { data, isSuccess, systemCode, message } = res;
        if (isSuccess) {
          if (JSON.stringify(transformQuestionTypeData(data)) !== '{}') {
            goTop();
          }
        }
        return {
          isSuccess, systemCode, message,
          data: transformQuestionTypeData(data),
        };
      },
    },
  });

  const transformDifficultObject = (array) => {
    if (!array) return {};
    let nextData = {};
    array.forEach((item) => {
      let newData = {
        ...nextData,
        [item.difficulty]: {
          answer: item.answer,
          question: item.question,
        }
      };
      nextData = newData;
    });
    return nextData;
  };

  const transformQuestion = (quesType, quesTypeName, array) => {
    if (!quesType || !quesTypeName || !array) return [];
    return array.map((item) => {
      return {
        ...item,
        quesType, quesTypeName
      };
    });
  };

  const transformQuestionTypeData = (data) => {
    if (!data) return {};
    let nextData = {};
    data.forEach((item) => {
      // if (globalExamPaperData.output === 'Quick') {
      //   if (!new RegExp(/SS|YN/g).test(item.questionType)) return null;
      // }
      let newData = {
        ...nextData,
        [item.questionTypeName]: {
          code: item.questionType,
          count: {
            answer: item.sum.answer,
            question: item.sum.question,
            difficulty: transformDifficultObject(item.diffcultyAggregate)
          },
          name: item.questionTypeName,
          question: transformQuestion(item.questionType, item.questionTypeName, item.questions)
        }
      };
      nextData = newData;
    });
    return nextData;
  };
  /////

  const [statePutEditExamPaper, sendPutEditExamPaper] = useMachine(fetchDataMachine, {
    services: {
      fetchData: async(_context, event) => {
        const res = await putEditExamPaper(event.payload);
        const { data, isSuccess, systemCode, message } = res;
        return {
          editIsSuccess: isSuccess, systemCode, message,
          data
        };
      },
    },
  });

  const [statePostExamEdit, sendPostExamEdit] = useMachine(fetchDataMachine, {
    services: {
      fetchData: async(_context, event) => {
        const res = await postExamEdit(event.payload);
        const { data, isSuccess, systemCode, message } = res;
        if (isSuccess) {
          doExportExam(event.payload.examUID);
        }
        return {
          editIsSuccess: isSuccess, systemCode, message,
          data
        };
      },
    },
  });

  const [statePostExportPaper, sendPostExportPaper] = useMachine(fetchDataMachine, {
    services: {
      fetchData: async(_context, event) => {
        const res = await postExportPaper(event.payload);
        const { data, isSuccess, systemCode, message } = res;
        if (isSuccess) {
          goTop();
        }
        return {
          exportIsSuccess: isSuccess, systemCode, message,
          exportPaperData: data
        };
      },
    },
  });

  // const { data } = stateGetDrawUpFastCacheQuery.context.result || {};
  const { data } = stateGetQuestionType.context.result || {};
  const { exportPaperData, exportIsSuccess } = statePostExportPaper.context.result || {};
  const { editIsSuccess } = statePostExamEdit.context.result || {};
  const disabled = useMemo(() => {
    let result = false;
    const checkArray = ['paperName', 'teacherSign', 'schoolName'];
    const advancedCheckArray = ['amount', 'paperSize', 'wordSetting', 'paperContents'];
    let pickupQuestion = [];
    switch (step) {
      case 5:
        if (createExamPaperParams?.outputType !== 'Files') {
          const { paperName = {}, outputType = '', examType = '' } = createExamPaperParams || {};
          const checkParams = {
            paperName: paperName?.value || '',
            outputType,
            examType
          };
          Object.entries(checkParams).forEach(([key, value]) => {
            if (value === '') result = true;
          });
        } else {
          Object.entries(createExamPaperParams).forEach(([key, value]) => {
            if ((key === 'grade' || key === 'room') && checkedSend.findIndex(item => item === 'classInfo') !== -1) {
              if (value.value === '') result = true;
            }
            const needCheck = ((checkArray.findIndex(item => item === key) !== -1 && checkedSend.findIndex(item => item === key) !== -1));
            if (needCheck) {
              if (value.value === '') result = true;
            }

            if (advancedCheckArray.findIndex(item => item === key) !== -1) {
              if (!value || value === '' || value.length === 0) result = true;
            }
          });
        }
        break;

      case 3:
        Object.entries(tableData).forEach(([key, value]) => {
          if (value?.pickUpQuestions) {
            Object.entries(value?.pickUpQuestions).forEach(([pickKey, pickValue]) => {
              pickupQuestion = pickupQuestion.concat(pickValue);
            });
          }
        });
        if (pickupQuestion.length === 0) return true;
        break;

      case 2:
        if (!totalQuesTypeData?.questionCount || totalQuesTypeData.questionCount === 0) return true;
        break;

      case 1:
        Object.entries(areaParams).forEach(([key, value]) => {
          if (!value || value.length === 0) result = true;
        });
        break;

      default:
        break;
    }
    return result;
  }, [step, areaParams, tableData, createExamPaperParams, totalQuesTypeData, checkedSend]);


  const isChangeData = useMemo(() => {
    let result = false;
    if (step === 1) {
      if (Object.keys(saveData.areaParams).length === 0 || Object.keys(areaParams).length === 0) return false;
      Object.entries(areaParams).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          if (saveData.areaParams[key].length === value.length) {
            if (saveData.areaParams[key].filter(item => !value.includes(item)).length > 0)result = true;
          } else {
            result = true;
          }
        } else {
          if (saveData.areaParams[key] !== value) result = true;
        }
      });
    } else if (step === 2) {
      if (Object.keys(saveData.tableData).length === 0 || Object.keys(tableData).length === 0) return false;
      let questionList = [];
      let saveQuestionList = [];
      Object.entries(tableData).forEach(([key, value], index) => {
        const quesTypeData = formateQuestionList(value.pickUpQuestions, questions);
        if (quesTypeData.length > 0) {
          questionList = questionList.concat(quesTypeData);
        }
      });
      Object.entries(saveData.tableData).forEach(([key, value], index) => {
        const quesTypeData = formateQuestionList(value.pickUpQuestions, questions);
        if (quesTypeData.length > 0) {
          saveQuestionList = saveQuestionList.concat(quesTypeData);
        }
      });
      if (questionList.length === saveQuestionList.length) {
        if (questionList.filter(item => !saveQuestionList.includes(item)).length > 0) result = true;
      } else {
        result = true;
      }
    }

    return result;
  }, [areaParams, step, tableData, saveData.areaParams]);

  // const disabledQuestionCount = useMemo(() => {
  //   if (!editCopyExamPaperData?.disabled || editCopyExamPaperData?.disabled.length === 0) return 0;
  //   let count = 0;
  //   editCopyExamPaperData?.disabled.forEach((item) => {
  //     count += item.amount;
  //   });
  //   return count;
  // }, []);

  // const editCopyQuestionCount = useMemo(() => {
  //   if (Object.keys(editCopyExamPaperData.tableData).length === 0) return 0;
  //   let count = 0;
  //   Object.entries(editCopyExamPaperData.tableData).forEach(([key, value]) => {
  //     count += value.inputValue.question;
  //   });
  //   return count;
  // }, []);

  const getSendAreaParams = (data) => {
    setAreaParams({ ...data });
  };
  const getTableData = (data) => {
    setTableData({ ...data });
  };
  const getKeyList = (data) => {
    setKeyList([...data]);
  };
  const getQuestions = (data) => {
    setQuestions([...data]);
  };
  const getTotalQuesTypeData = (data) => {
    setTotalQuesTypeData({ ...data });
  };
  const getCreateExamPaperParams = (data) => {
    setCreateExamPaperParams(data);
  };
  const getCheckedSend = (data) => {
    setCheckedSend(data);
  };
  const getSaveData = (key, data) => {
    setSaveData({ ...saveData, [key]: data });
  };
  const prevStep = () => {
    setStep(step - 1);
    goTop();
  };

  const onStepClick = (current) => {
    setIsGoBack(true);
    setStep(current + 1);
  };

  const resetData = () => {
    setSaveData({ ...initSaveData });
    setTableData({});
    setTotalQuesTypeData({});
    setQuestions([]);
    setCreateExamPaperParams({});
    setKeyList([]);
  };

  const nextStep = (jumpTo = null) => {
    setJumpStep(jumpTo);

    switch (step) {
      case 5:
        if (isEditCopy && editCopyExamPaperData?.actionType === 'Edit') {
          sendPostExamEdit(FETCH_DATA_EVENT.FETCH, {
            payload: {
              examUID: editCopyExamPaperData.paperData.uid,
              examName: sendParams.paperName.value,
              outputType: sendParams.outputType,
              drawUp: 'FastPattern',
              examType: sendParams.examType,
              isPublic: false,
              questionGroups,
            }
          });
        } else {
          sendPostExamCreate(FETCH_DATA_EVENT.FETCH, {
            payload: {
              eduSubject: searchParams.eduSubject,
              examName: sendParams.paperName.value,
              searchCondition: {
                bookIDs: isEditCopy ? reCreateSearchParams.bookIDs : searchParams.books,
                knowledgeIDs: isEditCopy ? reCreateSearchParams.knowledges : searchParams.knowledges,
                sourceIDs: isEditCopy ? reCreateSearchParams.sources : searchParams.sources,
                curriculum: isEditCopy ? reCreateSearchParams.curriculum : searchParams.curriculum,
                year: isEditCopy ? reCreateSearchParams.year : searchParams.year,
                version: isEditCopy ? reCreateSearchParams.version : searchParams.version,
              },
              examType: sendParams.examType,
              outputType: sendParams.outputType,
              drawUp: 'FastPattern',
              questionGroups,
            }
          });
        }
        break;

      case 2:
        if (totalQuesTypeData.score !== 100) {
          setModalFalse();
          setScoreModalToggle();
        } else {
          getSaveData('tableData', tableData);
          setModalFalse();
          setStep(3);
          setIsShowQuestionLimitText(false);
          goTop();
        }
        break;

      case 1:
        if (isChangeData) {
          setSaveData({
            ...initSaveData,
            areaParams,
            education: globalExamPaperData?.edu || 'J',
            subject: globalExamPaperData?.subject || 'GE',
            bookOptions: saveData.bookOptions,
          });
          setTableData({});
          setTotalQuesTypeData({});
          setQuestions([]);
          setCreateExamPaperParams({});
          setKeyList([]);
        } else {
          setSaveData({
            ...saveData,
            areaParams,
            education: globalExamPaperData?.edu || 'J',
            subject: globalExamPaperData?.subject || 'GE',
          });
        }
        //////
        sendGetQuestionType(FETCH_DATA_EVENT.FETCH, {
          payload: {
            eduSubject: globalExamPaperData?.edu + globalExamPaperData?.subject,
            bookIDs: areaParams.bookIDs,
            knowledges: areaParams.keys,
            sources: areaParams.source,
            curriculum: areaParams.curriculum,
            year: areaParams.year,
            version: areaParams.version,
            questionType: searchParams.questionTypes,
          }
        });
        /////
        break;
      default:
        if (jumpTo !== null) {
          setStep(jumpTo);
        } else {
          setStep(step + 1);
        }
        goTop();
        break;
    }
  };

  const searchParams = useMemo(() => {
    return {
      eduSubject: globalExamPaperData?.edu + globalExamPaperData?.subject,
      books: areaParams?.bookIDs,
      knowledges: areaParams?.keys,
      sources: areaParams?.source,
      curriculum: areaParams.curriculum,
      year: areaParams.year,
      version: areaParams.version,
      questionTypes: globalExamPaperData.output === 'Quick' ? ['SS', 'YN', 'GR'] : [],
    };
  }, [globalExamPaperData.edu, globalExamPaperData.subject, areaParams.bookIDs, areaParams.keys, areaParams.source, areaParams.year, areaParams.version, areaParams.curriculum, globalExamPaperData.output]);

  useEffect(() => {
    if (stateGetQuestionType.matches(FETCH_DATA_STATE.DONE)) {
      if (!data || JSON.stringify(data) === '{}') {
        setEmptyTextModalToggle();
        return null;
      } else {
        if (!isEditCopy) setStep(step + 1);
      }
    }
  }, [stateGetQuestionType.value]);

  useEffect(() => {
    if (statePostExportPaper.matches(FETCH_DATA_STATE.DONE) && exportIsSuccess) {
      setIsLoading(false);
      setStep(step + 1);
    }
  }, [statePostExamEdit.value, statePostExportPaper.value]);

  useEffect(() => {
    if (authState.context.userDetails?.userStatus.identity === 'Student') {
      history.push('/');
    }
  }, []);
  useEffect(() => {
    if (Object.keys(tableData).length > 0 && getCookie('createNewPaper') === null) {
      setCookie('createNewPaper', true, 1);
    }
  }, [tableData]);

  useEffect(() => {
    if (saveData.education === '' || saveData.subject === '') return;
    if (globalExamPaperData?.edu === saveData.education && globalExamPaperData?.subject === saveData.subject) return;
    resetData();
    setStep(1);
  }, [globalExamPaperData]);

  const isEditCopy = useMemo(() => {
    if (editCopyExamPaperData && JSON.stringify(editCopyExamPaperData) !== '{}') {
      setIsLoading(true);
      return true;
    } else {
      return false;
    }
  }, [editCopyExamPaperData]);

  const eduSubjectData = useMemo(() => {
    return isEditCopy ? editCopyExamPaperData : globalExamPaperData;
  }, [isEditCopy, editCopyExamPaperData, globalExamPaperData]);

  useEffect(() => {
    Object.entries(globalExamPaperData).forEach(([key, value]) => {
      if ((key === 'edu' || key === 'subject') && value === '') {
        if (!editCopyExamPaperData[key]) {
          history.push('./');
        }
      }
    });

    if (!editCopyExamPaperData || JSON.stringify(editCopyExamPaperData) === '{}') return;
    //   const { edu, subject, tableData, bookOptions, actionType, examUID, disabled } = editCopyExamPaperData;
    const {
      edu,
      subject,
      bookIDs,
      eduSubject,
      knowledgeIDs,
      selectedQuestion,
      sourceIDs,
      output,
      curriculum,
      year,
      version,
    } = editCopyExamPaperData;

    // 取得 題目類型
    setSendParams({ bookIDs, knowledges: knowledgeIDs, sourceIDs, eduSubject });
    sendGetQuestionType(FETCH_DATA_EVENT.FETCH, {
      payload: {
        eduSubject,
        bookIDs,
        knowledges: knowledgeIDs,
        sources: sourceIDs,
        curriculum,
        year,
        version,
        questionType: output === 'Quick' ? ['SS', 'YN', 'GR'] : [],
      }
    });

    setReCreateSearchParams({
      eduSubject,
      bookIDs,
      knowledges: knowledgeIDs,
      sources: sourceIDs,
      curriculum,
      year,
      version,
      questionTypes: output === 'Quick' ? ['SS', 'YN', 'GR'] : [],
    });

  }, []);

  const identity = useMemo(() => {
    return authState?.context?.userDetails?.onePaperIdentity || '';
  }, [authState]);

  const prevStepDisabled = useMemo(() => {
    if (!editCopyExamPaperData?.actionType) return false;
    if ((editCopyExamPaperData?.actionType === 'Edit' || editCopyExamPaperData?.actionType === 'Copy') && step <= 3) return true;
  }, [editCopyExamPaperData?.actionType, step]);

  ///  大更新
  const questionGroups = useMemo(() => {
    if (!tableData || JSON.stringify(tableData) === '{}') return;
    const nextData = keyList.map(key => {
      let questionList = [];
      if (JSON.stringify(saveData?.quesReviewQuestionRenderList) !== '{}' ) {
        saveData?.quesReviewQuestionRenderList[key] && saveData?.quesReviewQuestionRenderList[key].forEach((ques) => {
          questionList.push(ques?.uid);
        });
      } else {
        if (tableData[key]?.pickUpQuestions) {
          Object.values(tableData[key]?.pickUpQuestions).forEach(questions => {
            questions.forEach(question => {
              questionList = [...questionList, question?.uid];
            });
          });
        }
      }
      return ({
        typeCode: tableData[key]?.code,
        scoreType: tableData[key]?.inputValue?.score?.perQues ? 'PerQuestion' : 'PerAnswer',
        score: tableData[key]?.inputValue?.score?.perQues ? parseInt(tableData[key]?.inputValue?.score?.perQues) || 0 : parseInt(tableData[key]?.inputValue?.score?.perAns) || 0,
        questionList
      });
    }).filter(item => item?.questionList?.length > 0);
    return nextData;
  }, [tableData, keyList]);

  const defaultCountInputValue = {
    answer: '',
    question: '',
    score: {
      perQues: '',
      perAns: '',
      allScore: 0,
    },
    difficulty: {
      BEGIN: '',
      INTERMEDIATE: '',
      EXPERT: '',
    }
  };

  const formateTableData = (data) => {
    if (!data) return null;
    let nextData = {};
    Object.entries(data).forEach(([key, value], index) => {
      nextData = {
        ...nextData,
        [key]: {
          ...value,
          inputValue: defaultCountInputValue
        }
      };
    });
    return nextData;
  };

  useEffect(() => {
    if (!isEditCopy) return;
    if (!data) return;
    if (Object.keys(tableData).length > 0) return;
    const nextData = formateTableData(data);
    getTableData(nextData);
  }, [data, isEditCopy]);

  useEffect(() => {
    if (isEditCopy && JSON.stringify(tableData) !== '{}') {
      if (step < 3) setStep(3);
    }
  }, [isEditCopy, tableData]);

  useEffect(() => {
    if (reCreateExam) {
      initAllData();
    }
  }, [reCreateExam]);

  const initAllData = () => {
    setSaveData({ ...initSaveData });
    setResetToggle(false);
    setAreaParams({});
    setSendParams({});
    setQuestions([]);
    setTableData({});
    setKeyList([]);
    setSearchKey('');
    setTotalQuesTypeData({});
    setCreateExamPaperParams({});
    setCheckedSend([]);
    setJumpStep(null);
  };

  const jumpToStep5 = (boolean) => {
    setIsJumpToStep5(true);
    if (boolean) {
      setJumpStep(3);
    } else {
      setStep(3);
    }
  };

  const nextStepClickHandler = () => {
    // 確認是否有超過 出題上限。
    if (totalQuesTypeData.questionCount > questionNumLimit) {
      setQuestionCountModalToggle();
      setIsShowQuestionLimitText(true);
    } else {
      if (isChangeData) {
        if (step === 1 ) {
          setAreaModalToggle();
        }
        if (step === 2) {
          setModalToggle();
        }
      } else {
        nextStep();
      }
    }
  };

  const toFinalStepClickHandler = () => {
    // 確認是否有超過 出題上限。
    if (totalQuesTypeData.questionCount > questionNumLimit) {
      setQuestionCountModalToggle();
      setIsShowQuestionLimitText(true);
    } else {
      if (totalQuesTypeData.score !== 100) {
        setModalFalse();
        setScoreModalToggle();
        if ( step === 3) {
          setJumpStep(5);
        } else {
          jumpToStep5(true);
        }
      } else {
        setModalFalse();
        goTop();
        if ( step === 3) {
          setStep(5);
        } else {
          jumpToStep5(false);
        }
      }
    }
  };

  // 題數 上限
  const questionNumLimit = useMemo(() => {
    const type = createExamPaperParams?.outputType || globalExamPaperData.output;
    let num = 300;
    if (type === 'Files') num = 500;
    return num;
  }, [globalExamPaperData.output, createExamPaperParams.outputType]);

  useEffect(() => {
    setIsShowQuestionLimitText(false);
  }, [totalQuesTypeData.questionCount]);

  return (
    <StyledComputerQuestionPage className={className} data-testid="ComputerQuestionPage">
      <ExamPaperHeader pageName='電腦命題' globalExamPaperData={eduSubjectData} step={step} />
      {
        deviceData.isDesktop ?
          <StepBox isEditPaper={editCopyExamPaperData?.actionType} steps={steps} current={step - 1} onChange={onStepClick} stepdisabled={step === 6 ? true : false} type={'FastPattern'}>
            {
              (step === 1 && Object.keys(tableData).length > 0) && !isEditCopy &&
              <div className='warningBar'><ExclamationCircleSolid/>若變更選擇的範圍，則已選題型與試題將會被清空，請小心操作！</div>
            }

            {
              (step === 2 && questions.length > 0) && !isEditCopy &&
              <div className='warningBar'><ExclamationCircleSolid/>若變更選擇的題型、題數或答數，則已選試題將會被清空，請小心操作！</div>
            }

            {
              ((step === 2 || step === 3) && isShowQuestionLimitText) &&
              <div className='errorBar'><ExclamationCircleSolid/>每卷題數上限為{questionNumLimit}題，已選{totalQuesTypeData.questionCount}題，請減少題數。</div>
            }

            {/* {
              (step === 3 && saveData?.disabled && saveData?.disabled.length > 0) &&
              <div className='warningBar'>
                <div><ExclamationCircleSolid/>原試卷已選 {editCopyQuestionCount} 題試題，其中{disabledQuestionCount}題已被停用，將不會再顯示於試卷中：</div>
                <ul>
                  {
                    saveData?.disabled.map(item => (
                      <li>知識向度「{item.name}」 {item.amount} 題</li>
                    ))
                  }
                </ul>
              </div>
            } */}

            {
              step === 1 &&
              <StyledHomePageContent notLimitHeight={true}>
                <HomeAreaSelectContent
                  examPaperType="FastPattern"
                  resetToggle={resetToggle}
                  saveData={saveData}
                  areaParams={areaParams}
                  getSendAreaParams={getSendAreaParams}
                  globalExamPaperData={globalExamPaperData}
                  memberEduSubject={eduSubjectData}
                  getKeyList={getKeyList}
                  getTableData={getTableData}
                  getTotalQuesTypeData={getTotalQuesTypeData}
                  getSaveData={getSaveData}
                  identity={identity}
                  renderLoadingContent={renderLoadingContent}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  isEditCopy={isEditCopy}
                  isGoBack={isGoBack}
                  setIsGoBack={setIsGoBack}
                />
              </StyledHomePageContent>
            }
            {
              step === 2 &&
              <StyledHomePageContent>
                <HomeQuesTypeSelectContent
                  resetToggle={resetToggle}
                  tempTableData={tableData}
                  keyList={keyList}
                  examPaperInfo={data}
                  getKeyList={getKeyList}
                  getTableData={getTableData}
                  getTotalQuesTypeData={getTotalQuesTypeData}
                  globalExamPaperData={globalExamPaperData}
                  eduSubjectData={eduSubjectData}
                  renderLoadingContent={renderLoadingContent}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                />
              </StyledHomePageContent>
            }
            {
              step === 3 &&
              <StyledHomePageContent notLimitHeight={true}>
                <HomeQuestionSelectContent
                  examPaperInfo={data}
                  examPaperData={tableData}
                  searchKey={searchKey}
                  searchParams={searchParams}
                  examPaperTotalScoreData={totalQuesTypeData}
                  prevKeyList={keyList}
                  saveData={saveData}
                  eduSubjectData={eduSubjectData}
                  getSaveData={getSaveData}
                  getKeyList={getKeyList}
                  getTableData={getTableData}
                  getTotalQuesTypeData={getTotalQuesTypeData}
                  getQuestions={getQuestions}
                  globalExamPaperData={globalExamPaperData}
                  renderLoadingContent={renderLoadingContent}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  reCreateSearchParams={reCreateSearchParams}
                  isEditCopy={isEditCopy}
                  editCopyExamPaperData={editCopyExamPaperData}
                  isJumpToStep5={isJumpToStep5}
                  setIsJumpToStep5={setIsJumpToStep5}
                  setStep={setStep}
                />
              </StyledHomePageContent>
            }
            {
              step === 4 &&
              <StyledHomePageContent notLimitHeight={true}>
                <HomeQuestionReviewPage
                  examPaperInfo={data}
                  examPaperData={tableData}
                  searchKey={searchKey}
                  searchParams={searchParams}
                  examPaperTotalScoreData={totalQuesTypeData}
                  prevKeyList={keyList}
                  questions={questions}
                  saveData={saveData}
                  memberEduSubject={eduSubjectData}
                  getSaveData={getSaveData}
                  getKeyList={getKeyList}
                  getTableData={getTableData}
                  getTotalQuesTypeData={getTotalQuesTypeData}
                  renderLoadingContent={renderLoadingContent}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  eduSubjectData={eduSubjectData}
                />
              </StyledHomePageContent>
            }
            {
              step === 5 &&
              <StyledHomePageContent notLimitHeight={true}>
                <HomeLayoutOptionContent
                  examPaperInfo={data}
                  searchKey={searchKey}
                  searchParams={searchParams}
                  keyList={keyList}
                  examPaperData={tableData}
                  examPaperTotalScoreData={totalQuesTypeData}
                  saveData={saveData}
                  globalExamPaperData={globalExamPaperData}
                  eduSubjectData={eduSubjectData}
                  getCreateExamPaperParams={getCreateExamPaperParams}
                  getCheckedSend={getCheckedSend}
                  getSaveData={getSaveData}
                  organizationType={authState.context.userDetails?.userStatus.organization.type}
                  step={step}
                  renderLoadingContent={renderLoadingContent}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  areaParams={areaParams}
                  setOutSideSendParams={getSendParams}
                  isEditCopy={isEditCopy}
                  editCopyExamPaperData={editCopyExamPaperData}
                />
              </StyledHomePageContent>
            }
            {
              step === 6 &&
              <StyledHomePageContent>
                <HomeQuestionCompleteContent
                  onlineExamUID={createExamPaperParams?.examUID}
                  examUID={exportPaperData?.examUID}
                  UID={exportPaperData?.uid}
                  outputType={createExamPaperParams?.outputType}
                  renderLoadingContent={renderLoadingContent}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  globalExamPaperData={globalExamPaperData}
                  examPaperTotalScoreData={totalQuesTypeData}
                  sendParams={sendParams}
                  setStep={setStep}
                  setReCreateExam={setReCreateExam}
                  eduSubjectData={eduSubjectData}
                >

                </HomeQuestionCompleteContent>
              </StyledHomePageContent>
            }
            <UiBtnZone>
              {
                !isLoading &&
                <>
                  {
                    step !== 1 && step !== 6 &&
                    <Button
                      disabled={prevStepDisabled}
                      type={prevStepDisabled ? 'default' : 'solid'}
                      textcolor={prevStepDisabled ? '#D5D7DE' : '#A1A4B1'}
                      variant={prevStepDisabled ? 'ui02' : 'brand1'}
                      size='large'
                      isFull={false}
                      onClick={() => {prevStep();setIsGoBack(true);}}>
                  上一步
                    </Button>
                  }
                  {
                    step !== 6 &&
                    <Button
                      disabled={disabled}
                      variant={disabled ? 'ui02' : 'brand1'}
                      size='large'
                      isFull={false}
                      onClick={() => {nextStepClickHandler();setIsGoBack(false);}}
                    >
                      {
                        step !== 5 ?
                          '下一步' :
                          '輸出試卷'
                      }
                    </Button>
                  }

                  {
                    ( step !== 1 && step !== 4 && step !== 5 && step !== 6) &&
                    <Button
                      type="solid"
                      textcolor={'#EC7963'}
                      disabled={disabled}
                      variant="brand1"
                      size='large'
                      isFull={false}
                      onClick={() => {toFinalStepClickHandler();setIsGoBack(false);}}
                    >
                      <FileAltSolid color={'#EC7963'} />直接出卷
                    </Button>
                  }
                </>
              }
            </UiBtnZone>
          </StepBox>
          :
          // ----------------------------- 手機版本 --------------------------------------------------
          // ----------------------------- 手機版本 --------------------------------------------------
          // ----------------------------- 手機版本 --------------------------------------------------
          <MobileStepBox isEditPaper={editCopyExamPaperData?.actionType} steps={steps} current={step - 1} onChange={onStepClick} stepdisabled={step === 6 ? true : false} type={'FastPattern'}>
            {
              (step === 1 && Object.keys(tableData).length > 0) && !isEditCopy &&
              <div className='warningBar'><ExclamationCircleSolid/>若變更選擇的範圍，則已選題型與試題將會被清空，請小心操作！</div>
            }

            {
              (step === 2 && questions.length > 0) && !isEditCopy &&
              <div className='warningBar'><ExclamationCircleSolid/>若變更選擇的題型、題數或答數，則已選試題將會被清空，請小心操作！</div>
            }

            {
              (step === 2 && isShowQuestionLimitText) &&
              <div className='errorBar'><ExclamationCircleSolid/>每卷題數上限為{questionNumLimit}題，已選{totalQuesTypeData.questionCount}題，請減少題數。</div>
            }

            {/* {
              (step === 3 && saveData?.disabled && saveData?.disabled.length > 0) &&
              <div className='warningBar'>
                <div><ExclamationCircleSolid/>原試卷已選 {editCopyQuestionCount} 題試題，其中{disabledQuestionCount}題已被停用，將不會再顯示於試卷中：</div>
                <ul>
                  {
                    saveData?.disabled.map(item => (
                      <li>知識向度「{item.name}」 {item.amount} 題</li>
                    ))
                  }
                </ul>
              </div>
            } */}


            {
              step === 1 &&
              <StyledHomePageContent notLimitHeight={true}>
                <HomeAreaSelectContent
                  examPaperType="FastPattern"
                  resetToggle={resetToggle}
                  saveData={saveData}
                  areaParams={areaParams}
                  getSendAreaParams={getSendAreaParams}
                  globalExamPaperData={globalExamPaperData}
                  memberEduSubject={eduSubjectData}
                  getKeyList={getKeyList}
                  getTableData={getTableData}
                  getTotalQuesTypeData={getTotalQuesTypeData}
                  getSaveData={getSaveData}
                  renderLoadingContent={renderLoadingContent}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  isEditCopy={isEditCopy}
                  identity={identity}
                  isGoBack={isGoBack}
                  setIsGoBack={setIsGoBack}
                />
              </StyledHomePageContent>
            }
            {
              step === 2 &&
              <StyledHomePageContent notLimitHeight={true}>
                <HomeQuesTypeSelectContent
                  resetToggle={resetToggle}
                  tempTableData={tableData}
                  keyList={keyList}
                  examPaperInfo={data}
                  getKeyList={getKeyList}
                  getTableData={getTableData}
                  getTotalQuesTypeData={getTotalQuesTypeData}
                  globalExamPaperData={globalExamPaperData}
                  renderLoadingContent={renderLoadingContent}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                />
              </StyledHomePageContent>
            }
            {
              step === 3 &&
              <StyledHomePageContent notLimitHeight={true}>
                <HomeQuestionSelectContent
                  examPaperInfo={data}
                  examPaperData={tableData}
                  searchKey={searchKey}
                  searchParams={searchParams}
                  examPaperTotalScoreData={totalQuesTypeData}
                  prevKeyList={keyList}
                  saveData={saveData}
                  globalExamPaperData={globalExamPaperData}
                  eduSubjectData={eduSubjectData}
                  getSaveData={getSaveData}
                  getKeyList={getKeyList}
                  getTableData={getTableData}
                  getTotalQuesTypeData={getTotalQuesTypeData}
                  getQuestions={getQuestions}
                  renderLoadingContent={renderLoadingContent}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  reCreateSearchParams={reCreateSearchParams}
                  isEditCopy={isEditCopy}
                  editCopyExamPaperData={editCopyExamPaperData}
                  isJumpToStep5={isJumpToStep5}
                  setIsJumpToStep5={setIsJumpToStep5}
                  setStep={setStep}
                />
              </StyledHomePageContent>
            }
            {
              step === 4 &&
              <StyledHomePageContent notLimitHeight={true}>
                <HomeQuestionReviewPage
                  examPaperInfo={data}
                  examPaperData={tableData}
                  searchKey={searchKey}
                  searchParams={searchParams}
                  examPaperTotalScoreData={totalQuesTypeData}
                  prevKeyList={keyList}
                  questions={questions}
                  saveData={saveData}
                  getSaveData={getSaveData}
                  getKeyList={getKeyList}
                  getTableData={getTableData}
                  getTotalQuesTypeData={getTotalQuesTypeData}
                  memberEduSubject={eduSubjectData}
                  eduSubjectData={eduSubjectData}
                  renderLoadingContent={renderLoadingContent}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                />
              </StyledHomePageContent>
            }
            {
              step === 5 &&
              <StyledHomePageContent notLimitHeight={true}>
                <HomeLayoutOptionContent
                  searchKey={searchKey}
                  searchParams={searchParams}
                  keyList={keyList}
                  examPaperData={tableData}
                  examPaperTotalScoreData={totalQuesTypeData}
                  saveData={saveData}
                  globalExamPaperData={globalExamPaperData}
                  eduSubjectData={eduSubjectData}
                  getCreateExamPaperParams={getCreateExamPaperParams}
                  getCheckedSend={getCheckedSend}
                  getSaveData={getSaveData}
                  organizationType={authState.context.userDetails?.userStatus.organization.type}
                  renderLoadingContent={renderLoadingContent}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  areaParams={areaParams}
                  setOutSideSendParams={getSendParams}
                  isEditCopy={isEditCopy}
                  editCopyExamPaperData={editCopyExamPaperData}
                />
              </StyledHomePageContent>
            }
            {
              step === 6 &&
              <StyledHomePageContent>
                <HomeQuestionCompleteContent
                  onlineExamUID={createExamPaperParams?.examUID}
                  examUID={exportPaperData?.examUID}
                  UID={exportPaperData?.uid}
                  outputType={createExamPaperParams?.outputType}
                  renderLoadingContent={renderLoadingContent}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  globalExamPaperData={globalExamPaperData}
                  sendParams={sendParams}
                  setStep={setStep}
                  setReCreateExam={setReCreateExam}
                  examPaperTotalScoreData={totalQuesTypeData}
                  eduSubjectData={eduSubjectData}
                >

                </HomeQuestionCompleteContent>
              </StyledHomePageContent>
            }
            <UiBtnZone>
              {
                !isLoading &&
                <>
                  {
                    step !== 1 && step !== 6 &&
                    <Button
                      className={'prevStepBtn'}
                      disabled={prevStepDisabled}
                      type={prevStepDisabled ? 'default' : 'solid'}
                      textcolor={prevStepDisabled ? '#D5D7DE' : '#A1A4B1'}
                      variant={prevStepDisabled ? 'ui02' : 'brand1'}
                      size='large'
                      isFull={false}
                      onClick={() => {prevStep();setIsGoBack(true);}}>
                    上一步
                    </Button>
                  }
                  {
                    ( step !== 1 && step !== 4 && step !== 5 && step !== 6) &&
                    <Button
                      type="solid"
                      textcolor={'#EC7963'}
                      className={disabled ? 'disabledText' : 'goToSteps5Btn'}
                      disabled={disabled}
                      variant="brand1"
                      size='large'
                      isFull={false}
                      onClick={() => { toFinalStepClickHandler();setIsGoBack(false);}}
                    >
                      <FileAltSolid color={'#EC7963'}/>直接出卷
                    </Button>
                  }
                  {
                    step !== 6 &&
                    <Button
                      disabled={disabled}
                      variant={disabled ? 'ui02' : 'brand1'}
                      size='large'
                      isFull={false}
                      onClick={() => {nextStepClickHandler();setIsGoBack(false);}}
                    >
                      {
                        step !== 5 ?
                          '下一步' :
                          '輸出試卷'
                      }
                    </Button>
                  }
                </>
              }
            </UiBtnZone>
          </MobileStepBox>
      }
      <Modal
        visible={areaModalVisible}
        onCancel={setAreaModalFalse}
        className={'mobileModal'}
        title={
          <div>確定要變更範圍？</div>
        }
        footer={
          <div className="footerBtn footerBtnBox">
            <Button variant='ui01' onClick={() => {getSendAreaParams(saveData.areaParams);setAreaModalFalse(); setResetToggle(!resetToggle);}}>取消變更</Button>
            <Button variant={'brand1'} onClick={() => { nextStep(); setAreaModalFalse();setIsGoBack(false);}}>確定變更</Button>
          </div>
        }
      >
        <div className="modalContent">
          <div>變更後，原已選題型與試題將會被清空，需要重新操作後續步驟。</div>
          <div>確定變更請按「確定變更」</div>
          <div>使用原範圍請按「取消變更」</div>
        </div>
      </Modal>

      <Modal
        visible={modalVisible}
        onCancel={setModalFalse}
        className={'mobileModal'}
        title={
          <div>確定要變更題型與題數？</div>
        }
        footer={
          <div className="footerBtn footerBtnBox">
            <Button variant='ui01' onClick={() => {setModalFalse();getTableData(saveData.tableData); setResetToggle(!resetToggle); }}>取消變更</Button>
            <Button variant={'brand1'} onClick={() => { nextStep(); }}>確定變更</Button>
          </div>
        }
      >
        <div className="modalContent">
          <div>變更後，原已選試題將會被清空，需要重新操作後續步驟。</div>
          <div>確定變更請按「確定變更」</div>
          <div>使用原範圍請按「取消變更」</div>
        </div>
      </Modal>

      <Modal
        visible={scoreModalVisible}
        onCancel={setScoreModalFalse}
        className={'mobileModal'}
        title={
          <div>總分不等於 100 分，是否要繼續？</div>
        }
        footer={
          <div className="footerBtn footerBtnBox">
            <Button variant='ui01' onClick={setScoreModalFalse}>取消</Button>
            <Button
              variant={'brand1'}
              onClick={() => {
                getSaveData('tableData', tableData);
                if (jumpStep !== null) {
                  setStep(jumpStep);
                } else {
                  setStep(3);
                }
                setScoreModalFalse();
                goTop();
              }}>繼續</Button>
          </div>
        }
      />

      <Modal
        visible={emptyTextModalVisible}
        onCancel={setEmptyTextModalFalse}
        className={'mobileModal'}
        id={'emptyTextModal'}
        title={
          <div>該範圍無可用試題</div>
        }
        footer={
          <div className="footerBtn footerBtnBox">
            <Button
              variant={'brand1'}
              onClick={setEmptyTextModalFalse}
            >
              確認
            </Button>
          </div>
        }
      >
        <div>該範圍試題還在陸續更新中，請重新選擇範圍！</div>
      </Modal>

      <Modal
        visible={questionCountModalVisible}
        onCancel={setQuestionCountModalFalse}
        className={'questionCountModal mobileModal'}
        title={
          <div>題數超過出題上限，請減少題數</div>
        }
        footer={
          <div className="footerBtn footerBtnBox">
            <Button variant={'brand1'} onClick={() => { setQuestionCountModalFalse();}}>確定</Button>
          </div>
        }
      >
        <div className="modalContent">
          <div>{OUTPUT_TYPE_NAME[globalExamPaperData.output]}出題上限為{questionNumLimit}題，您當前已選擇{totalQuesTypeData.questionCount}題，請減少題數。</div>
        </div>
      </Modal>


    </StyledComputerQuestionPage>
  );
};